import { z } from 'zod';

import { LosId } from '../../BrandedIds';
import { ExternalLoanIdType } from '../../loan/ExternalLoanIdRecord';
import { zodTemporalInstant } from '../../Temporal';
import { zodBrandedString } from '../../utils';

export const ExportableExternalLoanId = z
  .object({
    loanId: zodBrandedString<LosId>(),

    type: ExternalLoanIdType,
    value: z.string(),
    /**
     * commented out for now while we determine the right date representation for this field.
     */
    // startDate: zodDateOrString,
    /**
     * commented out for now while we determine the right date representation for this field.
     */
    // soldDate: zodDateOrString.optional(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'ExternalLoanId' });
export type ExportableExternalLoanId = z.infer<typeof ExportableExternalLoanId>;
